import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

export const editColorants = (
    tabId,
    colorantList,
    unit,
    modified,
    scaling,
    shotsCoef,
    shotsName,
    customPackage = null,
    statsType = null
) => ({
    type: actionTypes.FORMULA_COLORANTS_EDIT,
    payload: {
        tabId: tabId,
        colorantList: colorantList,
        unit: unit,
        modified: modified,
        scaling: scaling,
        shotsCoef: shotsCoef,
        shotsName: shotsName,
        customPackage: customPackage,
        statsType: statsType
    }
});

export const saveFormulaMoreInfo = (tabId, moreInfo) => ({
    type: actionTypes.SAVE_FORMULA_MORE_INFO,
    payload: {
        tabId: tabId,
        moreInfo: moreInfo
    }
});

export const setMargin = (tabId, margin) => ({
    type: actionTypes.MAIN_TAB_SET_MARGIN,
    payload: {
        tabId: tabId,
        margin: margin
    }
});

export const updateFormula = (tabId, formulaData) => ({
    type: actionTypes.UPDATE_FORMULA_FROM_HISTORICAL_FORMULA,
    payload: {
        tabId: tabId,
        formulaData: formulaData
    }
});

export const deleteCustomer = (tabId) => ({
    type: actionTypes.MAIN_TAB_DELETE_CUSTOMER,
    payload: {
        tabId: tabId
    }
});

export const removeFormulaData = (tabId) => ({
    type: actionTypes.REMOVE_FORMULA_DATA,
    payload: {
        tabId: tabId
    }
});

export const setColorantPanelActiveUnit = (tabId, activeUnit) => ({
    type: actionTypes.SET_COLORANT_PANEL_ACTIVE_UNIT,
    payload: {
        tabId: tabId,
        activeUnit: activeUnit
    }
});

export const getColorImage = (tabId, fandeckId, colorId, local) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_COLOR_IMAGE,
        params: {
            fandeckId: fandeckId,
            colorId: colorId,
            local: local
        }
    },
    method: handlers.GET_COLOR_IMAGE,
    tabId: tabId,
    next: {
        fandeckId: fandeckId,
        colorId: colorId
    }
});

export const getAvailableFormulas = (
    tabId,
    productId,
    fandeckId,
    colorId,
    baseId,
    local,
    hasHistory,
    hasAlternatives,
    orderByRanking,
    searchPanelBase
) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_AVAILABLE_FORMULAS,
        params: {
            productId: productId,
            fandeckId: fandeckId,
            colorId: colorId,
            baseId: baseId,
            isLocal: local,
            orderByRanking: orderByRanking,
            historyAllBases: !searchPanelBase
        }
    },
    method: handlers.GET_AVAILABLE_FORMULAS,
    tabId: tabId,
    next: {
        hasHistory: hasHistory,
        hasAlternatives: hasAlternatives
    }
});

export const getAllColorantsForBip = (tabId, baseId, productId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ALL_COLORANTS_FOR_BIP,
        params: {
            baseId: baseId,
            productId: productId
        }
    },
    method: handlers.GET_ALL_COLORANTS_FOR_BIP,
    tabId: tabId
});

export const getFormulaById = (tabId, formulaCombinationId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_CUSTOM_FORMULA,
        params: {
            formulaCombinationId: formulaCombinationId
        }
    },
    method: handlers.GET_CUSTOM_FORMULA,
    tabId: tabId
});
